import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, Sparkles, History, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
import AuthModal from '../components/AuthModal';

const ReflectionsPromptPage = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50/50 to-pink-50/50 py-4 px-4">
      <div className="max-w-lg mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-lg p-6"
        >
          <div className="flex items-center justify-center mb-6">
            <div className="h-14 w-14 bg-gradient-to-r from-purple-100 to-pink-100 rounded-2xl flex items-center justify-center">
              <BookOpen className="h-7 w-7 text-purple-600" />
            </div>
          </div>

          <h1 className="text-2xl font-semibold text-center text-gray-900 mb-3">
            Your Personal Reflection Space
          </h1>
          
          <p className="text-gray-600 text-center mb-6">
            Create a free account to save your conversations and track your personal growth journey.
          </p>

          <div className="space-y-5">
            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-5 space-y-4">
              <h2 className="font-medium text-gray-900 flex items-center">
                <Sparkles className="h-5 w-5 text-purple-600 mr-2" />
                What You'll Get
              </h2>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <MessageCircle className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Unlimited conversations with Echo, your safe space to talk</span>
                </li>
                <li className="flex items-start">
                  <History className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Access your complete conversation history anytime</span>
                </li>
                <li className="flex items-start">
                  <BookOpen className="h-5 w-5 text-purple-600 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Personal reflections and insights from each conversation</span>
                </li>
              </ul>
            </div>

            <button
              onClick={() => setShowAuthModal(true)}
              className="w-full py-3 bg-gradient-to-r from-[#a85ff7] to-[#e457b5] text-white rounded-lg hover:opacity-90 transition-opacity font-medium"
            >
              Create Free Account
            </button>
          </div>
        </motion.div>
      </div>

      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        onSuccess={handleAuthSuccess}
        mode="sign-up"
      />
    </div>
  );
};

export default ReflectionsPromptPage;